import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

/**
 * Get available loans
 */
export const getAvailableLoans = createAction(
  '[Loans] Get Available Loans',
  props<{ loanType?: string }>()
);

export const getAvailableLoansSuccess = createAction(
  '[Loans] Get Available Loans Success',
  props<{ availableLoans: any[] }>()
);

export const getAvailableLoansFailure = createAction(
  '[Loans] Get Available Loans Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Get active loans
 */
export const getActiveLoans = createAction(
  '[Loans] Get Active Loans'
);

export const getActiveLoansSuccess = createAction(
  '[Loans] Get Active Loans Success',
  props<{ activeLoans: any[] }>()
);

export const getActiveLoansFailure = createAction(
  '[Loans] Get Active Loans Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Apply for a other loan types
 */

export const applyLoan = createAction(
  '[Loans] Apply Loan',
  props<{ payload: any }>()
);

export const applyLoanSuccess = createAction(
  '[Loans] Apply Loan Success',
  props<{ loanDetails: any }>()
);

export const applyLoanFailure = createAction(
  '[Loans] Apply Loan Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Apply for car loan
 */

export const applyCarLoan = createAction(
  '[Loans] Apply Car Loan',
  props<{ payload: any }>()
);

export const applyCarLoanSuccess = createAction(
  '[Loans] Apply Car Loan Success',
  props<{ loanDetails: any }>()
);

export const applyCarLoanFailure = createAction(
  '[Loans] Apply Car Loan Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Apply for home loan
 */

export const applyHomeLoan = createAction(
  '[Loans] Apply Home Loan',
  props<{ payload: any }>()
);

export const applyHomeLoanSuccess = createAction(
  '[Loans] Apply Home Loan Success',
  props<{ loanDetails: any }>()
);

export const applyHomeLoanFailure = createAction(
  '[Loans] Apply Home Loan Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Apply for a credit card lead
 */

export const applyCreditCardLoan = createAction(
  '[Loans] Apply Credit Card Loan',
  props<{ payload: any }>()
);

export const applyCreditCardLoanSuccess = createAction(
  '[Loans] Apply Credit Card Loan Success',
  props<{ loanDetails: any }>()
);

export const applyCreditCardLoanFailure = createAction(
  '[Loans] Apply Credit Card Loan Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Loan topup
 */

export const topUpLoan = createAction(
  '[Loans] Top up Loan ',
  props<{ payload: any }>()
);

export const topUpLoanSuccess = createAction(
  '[Loans] Top up Loan Success',
  props<{ loanDetails: any }>()
);

export const topUpLoanFailure = createAction(
  '[Loans] Top up Loan Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Repay loan
 */

export const repayLoan = createAction(
  '[Loans] Repay Loan ',
  props<{ payload: any }>()
);

export const repayLoanSuccess = createAction(
  '[Loans] Repay Loan Success',
  props<{ loanDetails: any }>()
);

export const repayLoanFailure = createAction(
  '[Loans] Repay Loan Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Loan purposes
 */
export const getLoanPurposes = createAction(
  '[Loans] Get Loan Purposes',
  props<{ loanType: 'home' | 'car' | 'credit-card' }>()
);

export const getLoanPurposesSuccess = createAction(
  '[Loans] Get Loan Purposes Success',
  props<{ loanType: 'home' | 'car' | 'credit-card'; purposes: any[] }>()
);

export const getLoanPurposesFailure = createAction(
  '[Loans] Get Loan Purposes Failure',
  props<{ loanType: 'home' | 'car' | 'credit-card'; error: HttpErrorResponse | string }>()
);
